import ToolBanner from "../components/assessment/cards_tool";
import FAQtool from "../components/assessment/ass-faq";
import SEO from "../utils/Seo";
const AssessmentPage = () => {
 
  
const metadata = {
  keywords: `
    self assessment test for mental health, mental health self assessment test,
    mental health self assessment, mental health self assessment online,
    online depression test, depression test online free, depression test online,
    anxiety test online free, anxiety test online, anxiety and depression test online,
    anxiety disorder test online free, anxiety disorder test online,
    depression anxiety test online, generalized anxiety test online,
    best mental health test, mental health screening tools,
    social interaction anxiety scale, social anxiety test, social anxiety disorder test
  `,
  description: `Take a free online self-assessment test for mental health, anxiety, and depression. 
  Get instant results with validated tools to understand your emotional well-being. 
  Confidential, easy, and accessible from anywhere.`
};



  return (
    <>
    <SEO keyword={metadata.keywords} description={metadata.description}/>
    <ToolBanner />
    <FAQtool />
    </>
  );
};

export default AssessmentPage;
